import { minutesToPercent } from "../../../../../components/RRule/timeline-range.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/continuous/ContinuousOccurrenceTrack.tsx
function ContinuousOccurrenceTrack({ segments }) {
	return /* @__PURE__ */ jsx("div", {
		className: "relative h-[1lh] w-full",
		children: segments.map((segment) => /* @__PURE__ */ jsx("div", {
			className: "bg-main absolute top-1/2 h-xxs -translate-y-1/2 rounded-full",
			style: {
				left: `${minutesToPercent(segment.start)}%`,
				width: `${minutesToPercent(segment.end - segment.start)}%`
			}
		}, `${segment.start}-${segment.end}`))
	});
}
//#endregion
export { ContinuousOccurrenceTrack };

//# sourceMappingURL=ContinuousOccurrenceTrack.js.map